import { useTranslation } from "react-i18next";

import { CanAccess } from "@refinedev/core";
import { useUpdate } from "@refinedev/core";
import { useState, useEffect } from "react";
import { Button, Spin } from "antd";

import { VersionUpgradeDialog } from "./VersionUpgradeDialog";

export const InstanceVersion = ({
  ver,
  platform,
  id,
  name,
  setStatus,
  allowedActions,
}) => {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);
  const [isUpgrade, setIsUpgrade] = useState(false);

  const handleUpgradeClick = (e) => {
    e.preventDefault();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const { mutate: upgrade } = useUpdate({
    resource: "instances",
    successNotification: (data1, values, resource) => {
      setIsUpgrade(false);
      setStatus(data1.status);
      return {
        message: t(`instances.actionResult.upgrade.success`, {
          id: values?.id,
        }),
        type: "success",
      };
    },
    errorNotification: (data1, values, resource) => {
      setIsUpgrade(false);
      return {
        message:
          t(`instances.actionResult.upgrade.failed`, {
            id: values?.id,
          }) +
          "--" +
          data1?.message,
        type: "error",
      };
    },
  });

  const handleUpgrade = ({ version }) => {
    setIsUpgrade(true);
    upgrade({ id, values: { data: { version }, action: "upgrade" } });
    return;
  };

  return (
    <>
      <div style={{ display: "flex", alignItems: "center" }}>
        <span>{ver}</span>
        <span style={{ paddingLeft: "10px" }}></span>
        <CanAccess resource="instances" action="updateVersion">
          {allowedActions?.indexOf("upgrade") != -1 && (
            <Spin spinning={isUpgrade}>
              <Button
                style={{ paddingLeft: "10px" }}
                onClick={(e) => handleUpgradeClick(e)}
              >
                {t("actions.upgrade", "Upgrade")}
              </Button>
            </Spin>
          )}
        </CanAccess>
      </div>
      <VersionUpgradeDialog
        open={open}
        onClose={handleClose}
        onUpgrade={handleUpgrade}
        version={ver}
        platform={platform}
        name={name}
      ></VersionUpgradeDialog>
    </>
  );
};
